import {logger} from './logger';

const isBadgeState = () => window.loginBadge && window.loginBadge.state;
const getLoginState = () => window.login && window.login.state;

const isLoginState = () =>
  new Promise(resolve => {
    const hasLoginState = getLoginState();
    if (hasLoginState) {
      logger(1700, 'Login.js is present');
      resolve(hasLoginState);
      return;
    }

    let timer = null;

    const done = () => {
      logger(1701, 'Login.js is present - from event');
      window.removeEventListener('login-load', done);
      clearTimeout(timer);
      resolve(window.login && window.login.consent);
    };

    logger(1702, 'Login.js is not present - waiting');
    timer = setTimeout(() => {
      logger(1703, 'Login.js is not present - from timeout');
      window.removeEventListener('login-load', done);
      resolve(false);
    }, 5000);

    window.addEventListener('login-load', done);
  });

const isStateSignedIn = (state, logString) => {
  logString = logString ? ` - ${logString}` : '';

  // login - logged in user
  // logout - orange user
  if (state && (state === 'login' || state === 'logout')) {
    logger(1704, `Signed IN${logString}`);
    return true;
  }

  logger(1705, `Signed OUT${logString}`);
  return false;
};

export const isUserSigned = () =>
  new Promise(async resolve => {
    const isState = (await isLoginState()) || isBadgeState();

    if (isState) {
      resolve(isStateSignedIn(isState, 'immediately'));
      return;
    }

    let badgeTimer = null;

    const done = e => {
      resolve(isStateSignedIn(e.detail && e.detail.state, 'from listener'));
      clearTimeout(badgeTimer);
      window.removeEventListener('badge', done);
    };

    badgeTimer = setTimeout(() => {
      window.removeEventListener('badge', done);
      resolve(false);
      logger(1706, 'Signed OUT - from timer');
    }, 5000);

    window.addEventListener('badge', done);
  });
